/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useRef } from 'react';

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import InlineMessage from '@atlaskit/inline-message';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const styles = cssMap({
	content: {
		paddingInline: token('space.100'),
		paddingTop: token('space.100'),
	},
});

type StoreDeepResearchRateLimitWarning = {
	removeRateLimiting: () => void;
};

// Default to 30s if nothing in the payload
const DISPLAY_DURATION_IN_SECONDS = 30;

export const StoreDeepResearchRateLimitWarning = ({
	removeRateLimiting,
}: StoreDeepResearchRateLimitWarning): JSX.Element => {
	const { formatMessage } = useIntl();
	const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		timeoutRef.current = setTimeout(() => {
			removeRateLimiting();
		}, DISPLAY_DURATION_IN_SECONDS * 1000);
		return () => {
			clearTimeout(timeoutRef.current);
		};
	}, [removeRateLimiting]);

	return (
		<Box xcss={styles.content} testId="conversation-assistant.store-rate-limit-warning">
			<InlineMessage
				appearance="warning"
				secondaryText={formatMessage(messages.deepResearchRateLimitWarning)}
			>
				{formatMessage(messages.deepResearchRateLimitWarningDescription)}
			</InlineMessage>
		</Box>
	);
};
